import { ChangeEvent } from 'react';

// NOTE: Any default values (initialized objects) should generally go in AppState.tsx
export enum SearchType {
	TextInput,
	MlsSearch
}
export interface UserSearch {
	searchType?: SearchType,
	searchPath?: string,
	currentAACValue?: string,
	mlsId?: string
}

export enum AreaType {
	Zip = 'zip',
	Geopoint = 'geo',
	Center = 'center',
	Address = 'address',
	MlsId = 'mls',
	County = 'county',
	City = 'city',
	Neighborhood = 'neighborhood',
	State = 'state',
	GeoIp = 'geoip',
}

export enum LocationOrigin {
	UserSearch = 'usersearch',
	MapBounds = 'mapbounds',
	UrlState = 'urlstate',
	CurrentLocation = 'currentlocation',
	Default = 'default'

}
// TODO: add comments for object properties (purpose and use)
export interface UserLocation {
	initialized: boolean
	areaType: AreaType
	address?: string
	city?: string
	state?: string
	zip?: string
	county?: string
	formattedAddress?: string
	zoomLevel?: number
	centerMap?: GeoPoint
	boundsElastic?: ElasticBounds
	mlsId?: string
	origin: LocationOrigin
}

// This is to afford being able to you this for Google or Elastic Search or Other
export interface GeoPoint {
	lat: number
	lng: number
}
export interface ElasticGeoPoint {
	lat: number
	lon: number
}
export interface ElasticBounds {
	bottom_right?: ElasticGeoPoint
	top_left?: ElasticGeoPoint
	top_right?: ElasticGeoPoint
	bottom_left?: ElasticGeoPoint
	top?: number
	bottom?: number
	left?: number
	right?: number
}
export interface UserFilters {
	initialized: boolean
	propertyType: string,
	homeTypes: string[],
	priceMin: number,
	priceMax: number,
	squareFeetMin: number,
	squareFeetMax: number,
	yearBuiltMin: number,
	yearBuiltMax: number,
	lotSizeMin: number,
	lotSizeMax: number,
	bedroomsMin: number,
	bathroomsMin: number,
	parkingSpotMin: number;
	hasGarage: boolean;
	maxHoaFee: number;
	isCapcenterListing?: boolean,
	searchArea?: number[][],
  openHouse?: boolean
}

export interface IpStackGeoPoint {
	latitude: number,
	longitude: number,
	city: string,
	state: string,
	zip: string,
}

export interface Properties {
	total: number,
	propertyArray: Property[]
}
export interface Property {
	id?: string,
	AccessibilityFeatures?: Array<string>,
	Appliances?: Array<string>,
	ArchitecturalStyle?: Array<string>,
	AssociationFee2?: number,
	AssociationFee2Frequency?: string,
	AssociationFee?: number,
	AssociationFeeFrequency?: string,
	AssociationYN?: boolean,
	AttachedGarageYN?: boolean,
	Basement?: Array<string>,
	BathroomsFull?: number,
	BathroomsHalf?: number,
	RawMlsBathroomsTotal?: number,
	BedroomsTotal?: number,
	BuildingAreaTotal?: number,
	BuyerOfficeMlsId?: string,
	BuyerAgencyCompensation?: string,
	BuyerAgentFirstName?: string,
	BuyerAgentFullName?: string,
	BuyerAgentKey?: string,
	BuyerAgentLastName?: string,
	BuyerAgentMlsId?: string,
	BuyerFinancing?: string[],
	BuyerOfficeKey?: string,
	BuyerOfficeName?: string,
	BuyerOfficePhone?: string,
	LivingArea?: number,
	CarportSpaces?: number,
	CarportYN?: boolean,
	City?: string,
	CloseDate: Date,
	OffMarketTimestamp: Date,
	ClosePrice: number,
	ConstructionMaterials?: Array<string>,
	Cooling?: Array<string>,
	CountyOrParish?: string,
	DaysOnMarket?: number,
	ElementarySchool?: string,
	ExteriorFeatures?: Array<string>,
	Fencing?: Array<string>,
	FireplaceFeatures?: Array<string>,
	FireplacesTotal?: number,
	FireplaceYN?: boolean,
	Flooring?: Array<string>,
	GarageYN?: boolean,
	Heating?: Array<string>,
	HighSchool?: string,
	InteriorFeatures?: Array<string>,
	lastSyncTimestamp?: string,
	ListAgentFullName?: string,
	ListAgentEmail?: string,
	ListAgentFirstName?: string,
	ListAgentLastName?: string,
	ListAgentPreferredPhone?: string,
	ListAOR?: string,
	ListingAgreement?: string,
	ListingId?: string,
	ListingService?: string,
	ListOfficeMlsId?: string,
	ListOfficeName?: string,
	ListPrice?: number,
	location?: any,
	LotSizeAcres?: number,
	LotSizeArea?: number,
	MiddleOrJuniorSchool?: string,
	MlsStatus?: string,
	OriginatingSystemName?: string,
	normalized_address?: any,
	UnparsedAddress?: string,
	UnitNumber?: string,
	OnMarketDate?: Date,
	OnMarketTimestamp?: Date,
	DerivedOnMarketTimestamp?: Date,
	Ownership?: string,
	OwnershipType?: string,
	ParcelNumber?: number,
	ParkingFeatures?: Array<string>,
	Photos?: any,
	PoolFeatures?: Array<string>,
	PoolPrivateYN?: boolean,
	PostalCity?: string,
	PostalCode?: string,
	PropertyType?: string,
	PublicRemarks?: string,
	Roof?: Array<string>,
	RoomsTotal?: number,
	Sewer?: Array<string>,
	StandardStatus?: string,
	StateOrProvince?: string,
  StatusChangeTimestamp?: Date,
	StreetDirPrefix?: string,
	StreetSuffix?: string,
	StreetDirSuffix?: string,
	StreetName?: string,
	StreetNumber?: string,
	Stories?: number,
	StoriesTotal?: number,
	SubdivisionName?: string,
	TaxAnnualAmount?: number,
	TaxAssessedValue?: number,
	TaxYear?: Date,
	WaterSource?: Array<string>,
	YearBuilt?: Date,
	Zoning?: string,
	isCapcenterListing?: boolean,
	AddressUrlString?: string,
	StreetAddressUrl?: string,
	CityAddressUrl?: string,
  OpenHouse?: Array<OpenHouseEntry>,
}

export interface OpenHouseEntry {
  Id: string;
  ListingId: string;
  OfficeMlsId: string;
  OpenHouseEndTime: string;
  OpenHouseStartTime: string;
  ListingKey: string;
  ModificationTimestamp: string;
  EntityEventSequenceNumeric: number;
  OpenHouseKey: string;
  OpenHouseStatus?: string;
  OpenHouseType: string;
  OriginatingSystemName: string;
  OpenHouseRemarks?: string;
}

export interface LocationState {
	hash: string,
	key: string,
	pathname: string;
	search: string,
	state: any
}
export interface InputBaseProps {
	inputMode?: 'search' | 'text' | 'none' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | undefined,
	id: string,
	type?: string,
	className?: string,
	placeholder?: string,
	value: string,
	onBlur?: (e: ChangeEvent<HTMLInputElement>) => void,
	onInput?: (e: ChangeEvent<HTMLInputElement>) => void,
	onChange: React.Dispatch<React.SetStateAction<string>>,
}
export interface ScheduleTourDateProps {
	day: any,
	month: string,
	monthNumeric: string,
	weekday: string,
	year: string
}

export interface ScheduleTourUrlProps {
	baseUrl: string,
	date: string,
	time: string,
	address: string,
	price: number
}
export interface CountyState {
	county: string,
	state: string,
	realtyIsActive: boolean
}

export interface CountiesApiParams {
	CountyId: number,
	CountyName: string,
	State: string,
	AmountLimit: number,
	FHALimit: number,
	IsRealtyApplied: boolean,
	region: string,
	regionId: number
}
